import { Modal } from "capitalrx-components-2.0";

import EmailModal from "./ModalTypes/EmailModal";
import TextModal from "./ModalTypes/TextModal";
import PrintModal from "./ModalTypes/PrintModal";

import { ModalProps } from "@/types/AdvantageCardRequest";
import styles from "./styles.module.scss";

const RequestModal = (props: ModalProps): JSX.Element => {
  const { visible, type, onClose } = props;

  return (
    <Modal className={styles.requestCardModal} visible={visible} onClose={onClose} testId={`${type}-modal`}>
      <ModalBody {...props} />
    </Modal>
  );
};

const ModalBody = (props: ModalProps) => {
  const { type, onClose } = props;
  if (type === "text") {
    return <TextModal onClose={onClose} />;
  }
  if (type === "email") {
    return <EmailModal onClose={onClose} />;
  }
  if (type === "print") {
    return <PrintModal onClose={onClose} />;
  }
};

export default RequestModal;
